<template>
  <v-container fluid class="slider-container">
    <v-row no-gutters class="slider">
      <v-col cols="12" class="slider-inside-container">
        <div class="slider-textbox">
          <slot></slot>
        </div>
        <img :src="require('@/assets/slider/Layer_209.png')" class="overlay-image"/>
        <v-img :src="image" class="slider-image"/>
      </v-col>
    </v-row>
    <v-row justify="center" style="background-color: #FFF;">
      <div class="grey-bar"></div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Slider',
  props: ['image'],
};
</script>

<style scoped>

</style>
